// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uUG9","col":"styles_col__1eN8K"};